import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonUtils } from '@app/common/util/common.util';

import { ConvertUtil } from '@app/common/util/convert.util';
import { DateUtils } from '@app/common/util/date.util';
import { DateFilterModel } from '@app/models/components/date-filter.model';
import { SelectDropdownModel } from '@app/models/components/select-dropdown.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'date-time-filter',
  templateUrl: './date-time-filter.component.html',
  styleUrls: ['./date-time-filter.component.css']
})
export class DateTimeFilterComponent implements OnInit {

  @Input()
  yearOptions: SelectDropdownModel[] = [];

  @Input()
  dateOptions: SelectDropdownModel[] = DateUtils.getListTimeSelect(this._translateService);

  @Input()
  hiddenDate: boolean = false;

  @Input()
  hiddenToDate: boolean = false;

  @Input()
  hiddenBtn: boolean = true;

  @Input()
  screen: String = "";
  
  @Input()
  labelDate: String = this._translateService.instant("common.003");

  // @Input()
  // labelDateUS: String = this._translateService.instant("common.024");

  @Input()
  hiddenImageSvg: boolean = false; 
  
  @Output()
  changeDateTimeFilter = new EventEmitter<DateFilterModel>;

  sDate: Date = new Date();
  eDate:  Date = new Date();
  
  now: Date = new Date();

  stringYear: string = this._translateService.instant("year");
  stringMonth: string = this._translateService.instant("month");
  stringDate: string = this._translateService.instant("day");

  fromYear: number = 0;
  fromMonth: number = 0;
  fromDate: number = 0;

  toYear: number = 0;
  toMonth: number = 0;
  toDate: number = 0;
  
  lang : String = CommonUtils.getLang();
  searchByLabelDate: String = this._translateService.instant("common.023");

  constructor(private _translateService: TranslateService) { }

  ngOnInit(): void {
    this.stringYear = this._translateService.instant('year');
    this.stringMonth = this._translateService.instant('month');
    this.stringDate = this._translateService.instant('day');

    const y = this.now.getFullYear();
    const m = this.now.getMonth() + 1;
    const d = this.now.getDate();

    this.fromYear = y;
    this.fromMonth = m;
    this.fromDate = d;

    this.toYear = y;
    this.toMonth = m;
    this.toDate = d;

    this.handleOnChangeDateFilter();
  }

  getSelectDropdown(value: String ): SelectDropdownModel {
    return {
      value: ConvertUtil.convertToSring(ConvertUtil.convertToZeroDecimal(value)),
      label: ConvertUtil.convertToSring(ConvertUtil.convertToZeroDecimal(value)),
    }
  }

  handleOnChangeDateFilter(): void {
    this.changeDateTimeFilter.emit({ 
      fromDate: {
        year: this.getSelectDropdown(this.fromYear.toString()),
        month: this.getSelectDropdown(this.fromMonth.toString()),
        date: this.getSelectDropdown(this.fromDate.toString()),
      },
      toDate: {
        year: this.getSelectDropdown(this.toYear.toString()),
        month: this.getSelectDropdown(this.toMonth.toString()),
        date: this.getSelectDropdown(this.toDate.toString()),
      },
    });
  }

  sDateEventEmitter(date:any){
    this.fromYear=date.substring(0,4)
    this.fromMonth=date.substring(5,7)
    this.fromDate=date.substring(8,10)
    this.handleOnChangeDateFilter();
  }
  eDateEventEmitter(date:any){
    this.toYear=date.substring(0,4)
    this.toMonth=date.substring(5,7)
    this.toDate=date.substring(8,10)
    this.handleOnChangeDateFilter();
  }


  setDatePicker(fy:number, fm:number, fd:number, ey:number, em:number, ed:number){
    this.sDate = new Date(fy, fm, fd)
    this.eDate = new Date(ey, em, ed);

    this.fromYear = this.sDate.getFullYear();
    this.fromMonth = this.sDate.getMonth()+1;
    this.fromDate = this.sDate.getDate();

    this.toYear = this.eDate.getFullYear();
    this.toMonth = this.eDate.getMonth()+1;
    this.toDate = this.eDate.getDate();
  }
  
  handleOnClickAll() {
    const sy = this.yearOptions[0].value;

    this.setDatePicker(Number(sy), 0, 1, this.now.getFullYear(), this.now.getMonth(), this.now.getDate());
    this.handleOnChangeDateFilter();
  }

  hanldeOnGetDateSelectedValue(seleted: SelectDropdownModel){
    switch (seleted.value) {
      case '0': {
        const y = this.now.getFullYear();
        const m = this.now.getMonth();
        this.setDatePicker(y, m, this.now.getDate(), y, m, this.now.getDate());
        
        break;
      }
      case '1': {
        const y = this.now.getFullYear();
        const m = this.now.getMonth();
        this.setDatePicker(y, m, 1, y, m, this.now.getDate());
        
        break;
      }
      case '2': {
        const y = this.now.getFullYear();
        const m = this.now.getMonth();

        const lastMonth = new Date(y, m, 1);
        lastMonth.setDate(lastMonth.getDate() - 1);

        const ed = lastMonth.getDate();
        this.setDatePicker(lastMonth.getFullYear(), lastMonth.getMonth(), 1, lastMonth.getFullYear(), lastMonth.getMonth(), ed);
        
        break;
      }
      case '3': {
         
        const now = new Date();
        const dateOfLast3Month = new Date();
        dateOfLast3Month.setMonth(now.getMonth() - 2);

        var l3y = dateOfLast3Month.getFullYear();
        var l3m = dateOfLast3Month.getMonth();
        

        var y = now.getFullYear();
        var m = now.getMonth();
        const ed = now.getDate();

        if(m == 0) {
          l3y = y - 1;
          l3m = 10;
        } else if(m == 1) {
          l3y = y - 1;
          l3m = 11;
        }

        this.setDatePicker(l3y, l3m, ed, y, m, ed);

        break;
      }
      case '4': {
        this.setDatePicker(this.now.getFullYear(), 0, 1, this.now.getFullYear(), this.now.getMonth(), this.now.getDate());
        
        break;
      }
      default: {
        break;
      }
    }
  this.handleOnChangeDateFilter();

  }
}
